import React from 'react';
import ProcessingButton from './ProcessingButton';

const NewsArticleInput = ({ 
  newsArticle, 
  onUpdateArticle, 
  onUploadArticle, 
  isUploading 
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Headline *
        </label>
        <input
          type="text"
          value={newsArticle.headline}
          onChange={(e) => onUpdateArticle('headline', e.target.value)}
          placeholder="Enter article headline"
          className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Source
        </label>
        <input
          type="text"
          value={newsArticle.source}
          onChange={(e) => onUpdateArticle('source', e.target.value)}
          placeholder="e.g., Reuters, Economic Times, PIB"
          className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Content *
        </label>
        <textarea
          value={newsArticle.content}
          onChange={(e) => onUpdateArticle('content', e.target.value)}
          placeholder="Paste the full article content here..."
          rows={8}
          className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        />
      </div>
      
      <ProcessingButton
        onClick={onUploadArticle}
        disabled={isUploading || !newsArticle.headline || !newsArticle.content}
        isLoading={isUploading}
        loadingText="Processing..."
        variant="purple"
        className="w-full"
      >
        Add Article
      </ProcessingButton>
    </div>
  );
};

export default NewsArticleInput;
